const PENDING_IMPORT_TOAST_STORAGE_KEY = 'import-spreadsheet-pending-toast';

export const storePendingImportToast = (layoutId, message) => {
  try {
    sessionStorage.setItem(PENDING_IMPORT_TOAST_STORAGE_KEY, JSON.stringify({ layoutId: String(layoutId), message }));
  } catch (error) {
    console.error('Could not store the spreadsheet import message:', error);
  }
};

export const consumePendingImportToast = (layoutId) => {
  try {
    const serializedToast = sessionStorage.getItem(PENDING_IMPORT_TOAST_STORAGE_KEY);
    sessionStorage.removeItem(PENDING_IMPORT_TOAST_STORAGE_KEY);

    if (!serializedToast) {
      return null;
    }

    const pendingToast = JSON.parse(serializedToast);
    return pendingToast.layoutId === String(layoutId) ? pendingToast.message : null;
  } catch (error) {
    console.error('Could not restore the spreadsheet import message:', error);
    return null;
  }
};
